module.exports = __webpack_public_path__ + "img/home.61caecb2.png";